import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'likes'
})
export class LikesPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value && value > 0) {
      const count = parseInt(value);
      if (count == 1) {
        return '1 Like';
      } else if (count > 1) {
        return `${count} Likes`;
      } else {
        return count;
      }
    } else if (value == 0) {
      return '0 Likes';
    }
    return value;
  }
}





// WEBPACK FOOTER //
// ./src/app/shared/pipes/likes.pipe.ts